// extracted by mini-css-extract-plugin
module.exports = {"container":"e_hr","title":"e_ir","titleIcon":"e_jr","summary":"e_kr","sourcesTitle":"e_lr","sources":"e_mr","source":"e_nr"};